import { useEffect, useState } from 'react'
import { ITag } from '../components/Tags/Tags.types'

export const cls = (...classes: (string | false | undefined)[]): string => {
  return classes.filter(Boolean).join(' ')
}

export const tagUrlify = (tag: ITag): string => {
  return tag.toLowerCase().replace('/', '-')
}

export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient
}
